import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { decryptAES } from "../../../utils/EncryptorUtils";
import { useNavigation } from "../../../hooks/useNavigation";
import { useAuthSlice } from "../../../redux/slice/authSlice";
import ExternalAccessLayout from "../../common/ExternalAccessLayout";
import ExternalAccessSignInDialog from "../../common/ExternalAccessSignInDialog";

const IVRBillerAccess: React.FC = () => {
  const { navigate } = useNavigation();
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const { isValid } = useAuthSlice();
  const [email, setEmail] = useState("");
  const [ivrNumber, setIvrNumber] = useState("");

  useEffect(() => {
    // Parse the URL parameters
    const params = new URLSearchParams(location.search);
    const encryptedIvrNumber = params.get("ivrNumber") || null;
    const encryptedEmail = params.get("email") || null;
    const iv = params.get("iv");
    const salt = params.get("salt");

    // Decrypt the parameters
    if (encryptedIvrNumber != null && encryptedIvrNumber !== "") {
      setIvrNumber(decryptAES(encryptedIvrNumber, iv, salt));
    }
    if (encryptedEmail != null && encryptedEmail !== "") {
      setEmail(decryptAES(encryptedEmail, iv, salt));
    }
  }, [location.search]);

  useEffect(() => {
    // If user is already logged in and email matches, navigate to ivr list
    if (
      isValid &&
      ivrNumber !== ""
    ) {
      navigate("/ivr_list", {
        state: { ivrNumber: ivrNumber },
        replace: true,
      });
    } else if (ivrNumber !== "" && email !== "") {
      setShowPopup(true);
    }
  }, [isValid, ivrNumber, email]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <ExternalAccessLayout
        title="IVR Access"
        description="Please sign in to view the IVR."
      />

      {showPopup && (
        <ExternalAccessSignInDialog
          onClose={handleClosePopup}
          email={email}
          allowEmailEdit={false}
          title="IVR Access"
          description="Please enter your password to access the IVR"
          submitButtonLabel="Access IVR"
          onAuthorized={() => {
            navigate("/ivr_list", {
              state: { ivrNumber: ivrNumber.trim() },
              replace: true,
            });
          }}
        />
      )}
    </>
  );
};

export default IVRBillerAccess;
